import { render, staticRenderFns } from "./cxdate.vue?vue&type=template&id=770d6624&scoped=true&"
import script from "./cxdate.vue?vue&type=script&lang=js&"
export * from "./cxdate.vue?vue&type=script&lang=js&"
import style0 from "./cxdate.vue?vue&type=style&index=0&id=770d6624&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770d6624",
  null
  
)

export default component.exports